import { useState, useRef, useCallback } from "react";

import {
  Popover,
  PopoverContent,
  PopoverAnchor,
} from "@bigbinary/neeto-atoms/primitives";
import { CircleX, User } from "lucide-react";
import { Profile } from "neetoteam";
import { useTranslation } from "react-i18next";

import { MENU_ITEM_CLASS } from "./constants";
import MenuButton from "./MenuButton";

import { DELETE_WORKSPACE_URL } from "../../constants";

const ProfileExpandMenu = ({ profileInfo }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [, setIsProfilePaneOpen] = Profile.usePaneState();
  const timeoutRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  }, []);

  return (
    <Popover {...{ open }} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <MenuButton
          {...{ profileInfo }}
          onClick={() => setOpen(prev => !prev)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </PopoverAnchor>
      <PopoverContent
        align="center"
        className="z-[99999] w-56 gap-0.5 p-1"
        side="right"
        sideOffset={8}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button
          className={MENU_ITEM_CLASS}
          data-testid="profile-my-profile-button"
          type="button"
          onClick={() => setIsProfilePaneOpen(true)}
        >
          <User size={18} />
          {t("neetoMolecules.sidebar.myProfile")}
        </button>
        {window.globalProps?.user?.isOwner && (
          <a
            className={MENU_ITEM_CLASS}
            data-testid="profile-cancel-account-button"
            href={DELETE_WORKSPACE_URL}
            rel="noreferrer"
            target="_blank"
          >
            <CircleX size={18} />
            {t("neetoMolecules.sidebar.cancelAccount")}
          </a>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default ProfileExpandMenu;
